import { AsyncPipe, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ALTabsComponent } from '@asamco/application-link/shared';
import { AsamcoUserService } from '@asamco/base';
import { BehaviorSubject, Subject, map } from 'rxjs';
import { ApplicationLogsOverviewComponent } from '../../application-logs-overview/application-logs-overview.component';
import { LinkTransferToolComponent } from '../../link-transfer-tool/link-transfer-tool.component';
import { AdminCompanyCreatorComponent } from '../tools/admin-company-creator/admin-company-creator.component';
import { AdminCompanyManagementGridComponent } from '../tools/admin-company-management-grid/admin-company-management-grid.component';
import { ApplicationsComponent } from '../tools/application/applications/applications.component';
import { AdminUserCompanyManagementGridComponent } from '../tools/admin-user-company-management-grid/admin-user-company-management-grid.component';
import { AdminCompanyRequestManagementGridComponent } from '../tools/admin-company-request-management-grid/admin-company-request-management-grid.component';
import { AdminCompanyAccessRequestManagementGridComponent } from '../tools/admin-company-access-request-management-grid/admin-company-access-request-management-grid.component';

@Component({
	selector: 'app-shell-admin-tooling-overview',
	templateUrl: './admin-tooling-overview.component.html',
	styleUrls: ['./admin-tooling-overview.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		NgIf,
		ALTabsComponent,
		NgSwitch,
		NgSwitchCase,
		AdminCompanyCreatorComponent,
		AdminCompanyManagementGridComponent,
		AdminCompanyRequestManagementGridComponent,
		AdminUserCompanyManagementGridComponent,
		AdminCompanyAccessRequestManagementGridComponent,
		ApplicationsComponent,
		AsyncPipe,
		ApplicationLogsOverviewComponent,
		LinkTransferToolComponent,
	],
})
export class AdminToolingOverviewComponent implements OnInit {
	public readonly isAdminSubject = new Subject<boolean>();
	public readonly isAdminObservable = this.isAdminSubject.asObservable();

	@ViewChildren(ALTabsComponent) tabsComponent: QueryList<ALTabsComponent>;

	public readonly tabInfos = [
		{
			id: 'company-creator',
			text: 'Company creator',
			icon: 'far fa-link',
		},
		{
			id: 'company-management',
			text: 'Companies',
			icon: 'far fa-hospitals',
		},
		{
			id: 'user-company-management',
			text: 'User companies',
			icon: 'far fa-hospital-user',
		},
		{
			id: 'company-request-management',
			text: 'Company requests',
			icon: 'far fa-users-cog',
		},
		{
			id: 'company-access-request-management',
			text: 'Company access requests',
			icon: 'far fa-link',
		},
		{
			id: 'applications',
			text: 'Applications',
			icon: 'far fa-users-class',
		},
		{
			id: 'application-logs',
			text: 'Application Logs',
			icon: 'far fa-list',
		},
		{
			id: 'link-transfer',
			text: 'Link Transfer',
			icon: 'far fa-file-export',
		},
	];

	public readonly selectedTabId$ = new BehaviorSubject(this.activatedRoute.snapshot.params.tab || 'company-creator');

	public readonly selectedTabIdBasedOnRoute$ = this.activatedRoute.params.pipe(
		map(params => params.tab),
	);

	constructor(private asamcoUserService: AsamcoUserService, private router: Router, private activatedRoute: ActivatedRoute) {}

	ngOnInit(): void {
		this.asamcoUserService.isAdmin().then(result => {
			this.isAdminSubject.next(result);
		});
		this.selectedTabId$.subscribe({
			next: selectedTabId => {
				this.router.navigate(['application-link', 'admin-tooling-overview', selectedTabId]);
			}
		})
	}
}
